export default "__VITE_ASSET__CnTQXqe4__"